import {
  Modal,
  ModalDialog,
  ModalClose,
  Typography,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
} from "@mui/joy";
import React from "react";

type CreateListModalProps = {
  open: boolean;
  onClose: () => void;
  onCreate: (title: string) => void;
};

export const CreateListModal = ({
  open,
  onClose,
  onCreate,
}: CreateListModalProps) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const title = (form.elements.namedItem("title") as HTMLInputElement).value;
    onCreate(title);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog>
        <ModalClose />
        <Typography level="h4" sx={{ mb: 2 }}>
          Create New List
        </Typography>
        <form onSubmit={handleSubmit}>
          <FormControl sx={{ mb: 2 }}>
            <FormLabel>Title</FormLabel>
            <Input name="title" required placeholder="Enter list name" />
          </FormControl>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button
              type="button"
              variant="plain"
              color="neutral"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button type="submit" variant="solid" color="primary">
              Create
            </Button>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};
